import { render } from "./MsgPopup.vue?vue&type=template&id=ca26f75c"
import script from "./MsgPopup.vue?vue&type=script&lang=js"
export * from "./MsgPopup.vue?vue&type=script&lang=js"

import "./MsgPopup.vue?vue&type=style&index=0&id=ca26f75c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__